import { getCart } from "../api/cart.api";
import { getWallet } from "../api/staff.api";
import { apiErrorMessage } from "./apiError";
import { parseWalletAmount } from "./wallet";
import { openRazorpayCheckout } from "./razorpay";

const cleanBookingBody = (body = {}) => {
  const clean = {};
  Object.entries(body).forEach(([key, value]) => {
    if (value == null) return;
    if (value === "" && key !== "notes") return;
    if (key === "walletAmount" || key === "staffId" || key === "transactionId") return;
    clean[key] = value;
  });
  return clean;
};

const acceptBooking = (response) => {
  const data = response?.data;
  if (!data || typeof data !== "object") {
    throw new Error("Booking failed");
  }
  if (data.duplicateItems || data.existingBookingId) {
    const err = new Error(data.message || "Booking failed");
    err.data = data;
    throw err;
  }
  if (data.success === false || data.isSuccessfull === false) {
    const err = new Error(data.message || "Booking failed");
    err.data = data;
    throw err;
  }
  return data;
};

const refreshWallet = async (onWallet) => {
  try {
    const res = await getWallet();
    onWallet?.(res.data);
  } catch {
    /* caller can still retry */
  }
};

/**
 * POST without transactionId. On 402, pay requiredOnline once, then resubmit.
 * 409 is shown to the caller and never retried.
 */
export const submitBookingWithPayment = async ({
  post,
  body,
  description,
  onWallet,
  refreshCart = false,
}) => {
  const base = cleanBookingBody(body);
  const run = (extra) => post({ ...base, ...extra });

  const finish = async (data) => {
    onWallet?.(data);
    if (refreshCart) {
      try {
        await getCart();
      } catch {
        /* cart list refreshes on next visit */
      }
    }
    return data;
  };

  try {
    return await finish(acceptBooking(await run()));
  } catch (err) {
    const status = err.response?.status;
    if (status === 409) {
      await refreshWallet(onWallet);
      throw new Error(apiErrorMessage(err, "Your wallet changed. Please try again."));
    }
    if (status !== 402) {
      if (err.data) throw err;
      if (err.response) throw new Error(apiErrorMessage(err));
      throw err;
    }

    const requiredOnline = parseWalletAmount(err.response.data?.requiredOnline);
    if (!(requiredOnline > 0)) {
      throw new Error(apiErrorMessage(err, "Online payment is required."));
    }

    let paymentId;
    await openRazorpayCheckout({
      amountInr: requiredOnline,
      description,
      onSuccess: (id) => {
        paymentId = id;
      },
    });

    try {
      return await finish(acceptBooking(await run({ transactionId: paymentId })));
    } catch (err2) {
      if (err2.response?.status === 409) {
        await refreshWallet(onWallet);
        throw new Error(apiErrorMessage(err2, "Your wallet changed. Please try again."));
      }
      if (err2.data) throw err2;
      if (err2.response) throw new Error(apiErrorMessage(err2));
      throw err2;
    }
  }
};
